// extracted by mini-css-extract-plugin
module.exports = {"overlay":"addProjectsModal_overlay__2ha7u","confirmation":"addProjectsModal_confirmation__cyy0W","wrapper":"addProjectsModal_wrapper__1Ar7T"};